import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/close.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
  tooltipInfo?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '24 24',
  },
  title: {
    color: '#3393F3',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  closeBtn: {
    float: 'right',
  },
  subTitle: {
    fontSize: 12,
    color: '#3393F3',
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    marginBottom: 12,
    '& input': {
      float: 'right',
    },
  },
  mobileHeader: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  typeHead: {
    fontSize: 14,
    color: 'rgba(24, 24, 24, 1)',
    fontWeight: 600,
  },
  typeDetail: {
    fontWeight: 400,
    fontSize: 14,
  },
})

const ChartTooltipModal = ({
  open,
  setOpen,
  handleClose,
  tooltipInfo,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <div className={classes.content}>
            {isMobile && (
              <div className={classes.header}>
                <div className={classes.mobileHeader}>
                  <span className={classes.title}>{tooltipInfo.title}</span>
                  <input
                    className={classes.closeBtn}
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
                {tooltipInfo.subTitle && (
                  <span className={classes.subTitle}>
                    {' '}
                    ({tooltipInfo.subTitle})
                  </span>
                )}
              </div>
            )}

            {!isMobile && (
              <div className={classes.header}>
                <span className={classes.title}>{tooltipInfo.title}</span>
                {tooltipInfo.subTitle && (
                  <span className={classes.subTitle}>
                    {' '}
                    ({tooltipInfo.subTitle})
                  </span>
                )}
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>What it shows: </span>
              <span className={classes.typeDetail}>
                {tooltipInfo.whatToShow}
              </span>
            </div>

            {tooltipInfo.purpose && (
              <div className={classes.detailContent}>
                <span className={classes.typeHead}>Purpose of chart: </span>
                <span className={classes.typeDetail}>
                  {tooltipInfo.purpose}
                </span>
              </div>
            )}

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>Things to look out for: </span>
              <span className={classes.typeDetail}>
                {tooltipInfo.thingsToLookOutFor}
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>Next best action: </span>
              <span className={classes.typeDetail}>
                {tooltipInfo.nextBestAction}
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(ChartTooltipModal)
